import { Component, Input, Output, EventEmitter, inject, OnInit, OnChanges, SimpleChanges, signal } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormGroup, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { CommonModule, formatDate } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { SelectOptions } from '../../../../../core/interfaces/select-options.interface';
import { NewRepApplicationService } from '../../new-rep-application-services/new-rep-application.service';
import { HttpStatusCode } from 'axios';
import { ViewNewRepApplication } from '../../new-rep-application-interfaces/viewnew-rep-application.interface';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MatDialog } from '@angular/material/dialog';
import { SessionStorageService } from '../../../../../core/services/session-storage/session-storage.service';
import { MatButtonModule } from '@angular/material/button';
import { SpouseDetailService } from './spouse-detail-service/spouse-detail-service';
import { SpouseDetailModel } from './spouse-detail-model/spouse-detail-model';
import { SnackbarService } from '../../../../../shared/services/snackbar/snackbar.service';
import { Router } from '@angular/router';
import { noWhitespace } from '../../../../../shared/validators/no-whitespace.validator';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-spouse-details',
  providers: [provideMomentDateAdapter(MY_FORMATS)],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    CommonModule,
    MatIcon,
    MatSelectModule,
    MatButtonModule
  ],
  templateUrl: './spouse-details.component.html',
  styleUrl: './spouse-details.component.scss'
})
export class SpouseDetailsComponent implements OnInit, OnChanges {

  @Output() next = new EventEmitter<string[]>();
  @Output() save = new EventEmitter<string>();

  @Input() formGroup!: FormGroup;
  @Input() maritalStatus: string = '';
  @Input() spousedetails!: ViewNewRepApplication;
  @Input() readonly = signal(false);

  status = 'Not Started';
  validator = '(Optional)';
  readonly message = 'This field is required.';
  data = history.state;

  private fb = inject(FormBuilder);
  private readonly matDialog = inject(MatDialog);
  private newRepApplicationService = inject(NewRepApplicationService);
  private sessionStorageService = inject(SessionStorageService);
  protected nationalities!: SelectOptions[];
  private spouseDetailService = inject(SpouseDetailService);
  private spouseDetailModel = new SpouseDetailModel();
  private snackBarService = inject(SnackbarService);
  private router = inject(Router);
  setSprinner = signal(false);

  role = '';
  isVisible = signal(false);


  async ngOnInit() {

    this.formGroup.addControl('spouseName', this.fb.control(''));
    this.formGroup.addControl('spousenric', this.fb.control(''));
    this.formGroup.addControl('spousedob', this.fb.control(''));
    this.formGroup.addControl('spouseNationality', this.fb.control(''));
    this.formGroup.addControl('spouseothernationality', this.fb.control(''));
    this.formGroup.addControl('spousefinorpassportno', this.fb.control(''));
    this.formGroup.addControl('spouseoccupation', this.fb.control(''));
    this.formGroup.addControl('spouseemployer', this.fb.control(''));



    this.getDropdownOptions();
    this.role = this.sessionStorageService.getCurrentUserRole();
    if ((this.role === 'DSU' || this.role === 'DSU Manager') && !this.spousedetails) {
      this.isVisible.set(true);
      this.getSpouseDetails();
    } else {
      await this.fetchSpouseData();

    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['maritalStatus']) {
      // console.log('Updated value:', changes['maritalStatus'].currentValue);
      const value = changes['maritalStatus'].currentValue;
      this.handleMartialChanges(value);
      this.handleFormStatus();
    }
  }

  fetchSpouseData(): void {
    // if (this.spousedetails) {}
    this.formGroup.controls['spouseName']?.setValue(this.spousedetails?.spouseNameNric);
    this.formGroup.controls['spousenric']?.setValue(this.spousedetails?.spouseNricNo);
    if (this.spousedetails?.spouseDob !== '1900-01-01T00:00:00Z') {
      this.formGroup.controls['spousedob']?.setValue(this.spousedetails?.spouseDob);
    } else {
      this.formGroup.controls['spousedob']?.setValue('');
    }
    if (this.spousedetails?.spouseNationality != '') {
      if (this.spousedetails?.spouseNationality == 'Singapore Citizen') {
        this.formGroup.controls['spouseNationality']?.setValue(this.spousedetails?.spouseNationality);
        this.formGroup.controls['spouseothernationality']?.setValue('Singaporean');
      } else if (this.spousedetails?.spouseNationality.split(',')[0] == 'Singapore Permanent Resident') {
        const nationality = this.spousedetails?.spouseNationality.split(',');
        this.formGroup.controls['spouseNationality']?.setValue(nationality[0]);
        this.formGroup.controls['spouseothernationality']?.setValue(nationality[1]);
      } else {
        const nationality = this.spousedetails?.spouseNationality.split(',');
        this.formGroup.controls['spouseNationality']?.setValue(nationality[0]);
        this.formGroup.controls['spouseothernationality']?.setValue(nationality[1]);
      }
    }
    this.formGroup.controls['spousefinorpassportno']?.setValue(this.spousedetails?.spouseFinPassportNo);
    this.formGroup.controls['spouseoccupation']?.setValue(this.spousedetails?.spouseOccupation);
    this.formGroup.controls['spouseemployer']?.setValue(this.spousedetails?.nameOfEmployer);
    const value = this.maritalStatus;
    this.handleMartialChanges(value);

    if (this.readonly() == true) {
      if (this.formGroup.valid) {
        this.status = 'Completed';
        this.next.emit([this.status, 'submitted']);
      } else if (this.formGroup.invalid) {
        const anyFilled = Object.values(this.formGroup.value).some(v => v && v.toString().trim() !== '');
        if (anyFilled) {
          this.status = 'In Progress';
          this.next.emit([this.status, 'submitted']);
        } else {
          this.status = 'Not Started';
          this.next.emit([this.status, 'submitted']);
        }
      }
      this.formGroup?.disable();
      this.formGroup.controls['spousenric']?.disable();
      this.formGroup.controls['spouseothernationality']?.disable();
      if (this.spousedetails?.spouseNationality == 'Singapore Citizen') {
        this.formGroup.controls['spouseothernationality']?.setValue('Singaporean');
      } else {
        const nationality = this.spousedetails?.spouseNationality.split(',');
        this.formGroup.controls['spouseothernationality']?.setValue(nationality[1]);
      }
    } else {
      this.formGroup?.enable();
      if (this.spousedetails?.spouseNationality == 'Singapore Citizen') {
        this.formGroup.controls['spouseothernationality']?.disable();
        this.formGroup.controls['spousefinorpassportno']?.disable();
      } else {
        this.formGroup.controls['spouseothernationality']?.enable();
        const nationality = this.spousedetails?.spouseNationality.split(',');
        this.formGroup.controls['spouseothernationality']?.setValue(nationality[1]);
      }
      if (this.formGroup.valid) {
        this.status = 'Completed';
        this.next.emit([this.status, 'submitted']);
      } else if (this.formGroup.invalid) {
        const anyFilled = Object.values(this.formGroup.value).some(v => v && v.toString().trim() !== '');
        if (anyFilled) {
          this.status = 'In Progress';
          this.next.emit([this.status, 'submitted']);
        } else {
          this.status = 'Not Started';
          this.next.emit([this.status, 'submitted']);
        }
      }
    }

    this.handleFormStatus();
  }




  async getDropdownOptions() {

    const responseData = await this.newRepApplicationService
      .getDropdownOptions()
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    if (responseData.status === HttpStatusCode.Ok) {
      this.nationalities = responseData.data.responsedata.constants.nationality_list;

    }
  }

  handleMartialChanges(value: string) {
    if (this.readonly()) {
      return;
    }
    const spouseName = this.formGroup.get('spouseName');
    const spousenric = this.formGroup.get('spousenric');
    const spousedob = this.formGroup.get('spousedob');
    const spouseNationality = this.formGroup.get('spouseNationality');
    const spouseoccupation = this.formGroup.get('spouseoccupation');
    const spousefinorpassportno = this.formGroup.get('spousefinorpassportno');
    const spouseothernationality = this.formGroup.get('spouseothernationality');

    if (value === 'married') {
      this.validator = '';
      spouseName?.setValidators([Validators.required, noWhitespace]);
      spousenric?.setValidators([Validators.required]);
      spousedob?.setValidators([Validators.required]);
      spouseNationality?.setValidators([Validators.required]);
      spouseoccupation?.setValidators([Validators.required, noWhitespace]);

      this.handleNationalityChanges(value);

    } else {
      this.validator = '(Optional)';
      spouseName?.clearValidators();
      spousenric?.clearValidators();
      spousedob?.clearValidators();
      spouseNationality?.clearValidators();
      spouseoccupation?.clearValidators();
      spousefinorpassportno?.clearValidators();
      spouseothernationality?.clearValidators();

      // spouseName?.reset();
      // spousenric?.reset();
      // spousedob?.reset();
      // spouseNationality?.reset();
      // spouseoccupation?.reset();
      // spousefinorpassportno?.reset();
      // spouseothernationality?.reset();
    }

    // IMPORTANT: update each control
    spouseName?.updateValueAndValidity();
    spousenric?.updateValueAndValidity();
    spousedob?.updateValueAndValidity();
    spouseNationality?.updateValueAndValidity();
    spouseoccupation?.updateValueAndValidity();
    spousefinorpassportno?.updateValueAndValidity();
    spouseothernationality?.updateValueAndValidity();
  }

  handleNationalityChanges(value: string) {
    const spouseNationality = this.formGroup.get('spouseNationality');

    const spousenric = this.formGroup.get('spousenric');
    const spousefinorpassportno = this.formGroup.get('spousefinorpassportno');
    const spouseothernationality = this.formGroup.get('spouseothernationality');
    if (value === 'married') {
      spouseNationality?.valueChanges.subscribe(value => {
        if (value === 'others') {
          // const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
          //   width: '500px',
          //   disableClose: true,
          //   data: {
          //     message: 'Are you sure want change the nationality releted Attachement also removed?'
          //   }
          // });

          // dialogRef.afterClosed().subscribe(async result => {
          //   if (result.data === true) {
          spousenric?.disable();
          spousenric?.clearValidators();
          spousenric?.reset();
          spousefinorpassportno?.setValidators([Validators.required, noWhitespace]);
          spouseothernationality?.setValidators([Validators.required]);
          spousefinorpassportno?.enable();
          spouseothernationality?.reset();
          spouseothernationality?.enable();
          //   } else {
          //     // console.log('User cancelled');
          //     if (spouseothernationality?.value == 'Singaporean') {
          //       spouseNationality?.setValue('Singapore Citizen');
          //     } else {
          //       spouseNationality?.setValue('Singapore Permanent Resident');
          //     }
          //   }
          // });
        } else if (value === 'Singapore Permanent Resident') {
          spouseothernationality?.reset();
          spouseothernationality?.enable();
          spousenric?.setValidators([Validators.required, noWhitespace]);
          spousenric?.enable();
          spousefinorpassportno?.clearValidators();
          spousefinorpassportno?.reset();
          spousefinorpassportno?.disable();
        } else if (value === 'Singapore Citizen') {
          spousenric?.enable();
          spousenric?.setValidators([Validators.required, noWhitespace]);
          spouseothernationality?.setValue('Singaporean');
          spouseothernationality?.disable();
          spousefinorpassportno?.clearValidators();
          spousefinorpassportno?.reset();
          spousefinorpassportno?.disable();

        }


      });
    }
    // Update all affected controls once
    [spousenric, spousefinorpassportno, spouseothernationality].forEach(ctrl =>
      ctrl?.updateValueAndValidity()
    );
  }


  handleFormStatus() {
    // Nothing in a read-only section can be a user edit - the form is disabled.
    // Every emission here is programmatic: the saved data being loaded, and
    // disable() itself, which empties formGroup.value so it can never match the
    // baseline below. Each one overwrote the status the section had just derived
    // from that data, leaving a completed application reading "In Progress".
    if (this.readonly()) return;

    const initialValue = this.formGroup.getRawValue();

    this.formGroup.valueChanges.subscribe(currentValue => {
      const hasChanged =
        JSON.stringify(initialValue) !== JSON.stringify(currentValue);

      if (hasChanged) {
        this.status = 'In Progress';
        this.next.emit([this.status, 'change']);
      }
    });
  }

  saveAndContinue() {
    this.formGroup.markAllAsTouched();
    if (this.formGroup.valid) {
      this.status = 'Completed';

    }
    this.next.emit([this.status, 'submit']);
  }

  async saveSection() {
    this.setSprinner.set(true);
    let saveSpouseDetail = new SpouseDetailModel();
    saveSpouseDetail.setPiasrepCode(this.data.applicant.repcode);
    saveSpouseDetail.setSpouseNameNric(this.formGroup.get('spouseName')?.value);
    saveSpouseDetail.setSpouseNricNo(this.formGroup.get('spousenric')?.value);
    // const formatted = formatDate(
    //   this.formGroup.get('spousedob')?.value,
    //   'yyyy-MM-dd',
    //   'en-US'
    // );
    const sd = this.formGroup.get('spousedob')?.value;
    if (sd) {
      const formatted = formatDate(sd, 'yyyy-MM-dd', 'en-US');
      saveSpouseDetail.setSpouseDob(formatted + 'T00:00:00Z');
    } else {
      saveSpouseDetail.setSpouseDob(sd);
    }
    if (this.formGroup.get('spouseNationality')?.value == 'Singapore Citizen') {
      saveSpouseDetail.setSpouseNationality(this.formGroup.get('spouseNationality')?.value);
    } else {
      saveSpouseDetail.setSpouseNationality(this.formGroup.get('spouseNationality')?.value + ',' + this.formGroup.get('spouseothernationality')?.value);
    }
    saveSpouseDetail.setSpouseFinPassportNo(this.formGroup.get('spousefinorpassportno')?.value);
    saveSpouseDetail.setSpouseOccupation(this.formGroup.get('spouseoccupation')?.value);
    saveSpouseDetail.setNameOfEmployer(this.formGroup.get('spouseemployer')?.value);
    const responseData = await this.spouseDetailService
      .spouseDetails(saveSpouseDetail)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.save.emit('saved');
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  cancelSection() {
    this.save.emit('cancelled');
  }

  // GET SPOUSE DETAILS
  async getSpouseDetails() {
    this.setSprinner.set(true);
    let repCode = this.data.applicant.repcode;

    const responseData = await this.spouseDetailService
      .getSpouseDetails(repCode)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {

      this.spousedetails = responseData.data.responsedata.personal_particular;
      this.fetchSpouseData();

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }

  }

}